// extracted by mini-css-extract-plugin
module.exports = {"drop_files":"DropFiles_drop_files__9VAuA","active":"DropFiles_active__Les0i"};